export function variantAvailability(variant = {}) {
  const mode = variant.fulfillment_mode || "hybrid";
  const tracked = variant.inventory_tracked ?? typeof variant.available === "number";
  const available = Math.max(0, Number(variant.available || 0));

  if (mode === "made_to_order" || (!tracked && mode === "hybrid")) {
    return { label: "Made to order", purchasable: true, available: 0 };
  }
  if (!tracked) return { label: "Available", purchasable: true, available: 0 };
  if (available > 0) {
    return { label: `${available} in stock`, purchasable: true, available };
  }
  if (mode === "hybrid") {
    return { label: "Made to order", purchasable: true, available: 0 };
  }
  return { label: "Out of stock", purchasable: false, available: 0 };
}

export function variantCanBePurchased(variant) {
  return variantAvailability(variant).purchasable;
}
